<template>
  <div>
    <div class="the_outer_layer">
      <div class="centent_new_people">
        <img
          class="the_title"
          src="@/assets/images/newPeoplebiaoti.png"
          alt=""
        />
        <div class="centent_center">
          <div class="firstCentent">
            <img
              class="centent_center_b"
              src="@/assets/images/diyibu.png"
              alt=""
            />
            <span class="line"></span>
            <div class="centent_center_f">根据您的需求选择贷款产品进行申请</div>
            <img class="home_page" src="@/assets/images/shouye_a.png" alt="" />
          </div>
          <div class="secondCentent">
            <img
              class="centent_center_b"
              src="@/assets/images/dierbu.png"
              alt=""
            />
            <span class="line"></span>
            <div class="centent_center_two">
              <p>填写您的资料信息，完成贷款申请审批</p>
              <p>实时在线获得额度</p>
            </div>
            <img style="width:100%" src="@/assets/images/shouye_b.png" alt="" />
          </div>
          <div class="thirdCentent">
            <img
              class="centent_center_b"
              src="@/assets/images/disanbu.png"
              alt=""
            />
            <span class="line"></span>
            <div class="centent_center_three">
              <p>在线提款，实时到账</p>
            </div>
            <img class="home_page" src="@/assets/images/shouye_c.png" alt="" />
          </div>
        </div>
        <div class="centent_center_footer">
          <div class="entry" @click="entry">立即申请</div>
          <p>*平台所提供的产品服务以最终申请为准</p>
        </div>
      </div>
    </div>
    <img
      class="returnHome"
      src="@/assets/images/returnHome.png"
      alt=""
      @click="entry"
    />
  </div>
</template>
<script>
export default {
  name: 'newPeople',
  data() {
    return {};
  },
  methods: {
    entry() {
      this.$router.push('/supermarket/v2/');
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
}
.the_outer_layer {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/newPeoplebeijing.png');
}
.the_title {
  margin-top: 70px;
  width: 96%;
  margin-left: 3%;
}
.centent_new_people {
  width: 100%;
  height: auto;
}
.centent_center {
  width: 91%;
  height: auto;
  background: #fff;
  margin: -8px auto 0;
  box-shadow: 0 4px 55px 0 rgba(0, 0, 0, 0.12);
  border-radius: 14px;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.centent_center_b {
  width: 40px;
  height: 40px;
  margin-top: 25px;
  padding: 0 0 10px 0;
  /*border-bottom: 3px solid #ffccbf87;*/
}
.line {
  display: block;
  width: 20px;
  height: 4px;
  background: rgba(255, 204, 191, 1);
  margin: 0 auto;
}
.centent_center_f {
  top: 45px;
  position: absolute;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #593820;
}
.centent_center_two {
  top: 420px;
  position: absolute;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #593820;
}
.centent_center_three {
  top: 800px;
  position: absolute;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #593820;
}
.home_page {
  width: 170px;
  height: 302px;
}
.centent_center_footer {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
.centent_center_footer p {
  opacity: 0.6;
  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #ebebeb;
  letter-spacing: 0;
  text-align: center;
}
.centent_center_footer div {
  width: 309px;
  height: 39px;
  background-image: linear-gradient(-150deg, #f1cd8a 11%, #eab76a 100%);
  box-shadow: 0 6px 44px 0 rgba(186, 45, 45, 0.38);
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  line-height: 39px;
  color: #ffffff;
  margin-bottom: 10px;
}
.returnHome {
  width: 75px;
  height: 75px;
  position: fixed;
  bottom: 10%;
  right: 20px;
}
.firstCentent {
  width: 100%;
  text-align: center;
  position: relative;
}
.firstCentent .centent_center_f {
  width: 100%;
  text-align: center;
}
.secondCentent {
  position: relative;
  width: 100%;
  text-align: center;
}
.secondCentent .centent_center_two {
  width: 100%;
  position: absolute;
  top: 40px;
  text-align: center;
}
.thirdCentent {
  position: relative;
  width: 100%;
  text-align: center;
}
.thirdCentent .centent_center_three {
  width: 100%;
  position: absolute;
  top: 50px;
  text-align: center;
}
</style>
